import React from "react";
import { Wrapper, ContentTypeRender } from "nystem-components";

const BootstrapComputedClass = ({ view, model, path }) => {
  const insertVal = (val) =>
    val.replace(
      /\{([a-z_.]+)\}/gim,
      (str, p1, offset, s) => view.getValue(p1.replace(".", path + ".")) || ""
    );

  const className = model.className ? model.className.join(" ") : "";

  if (model.row)
    return (
      <Wrapper className={insertVal(className)}>
        <Wrapper className="row">
          <ContentTypeRender path={path} items={model.item} />
        </Wrapper>
      </Wrapper>
    );
  return (
    <Wrapper className={insertVal(className)} renderAs={model.renderAs}>
      <ContentTypeRender path={path} items={model.item} />
    </Wrapper>
  );
};
export default BootstrapComputedClass;
